// frontend/src/lib/legal.ts
// ───────────────────────────────────────────────────────────────────
// Constantes des pages légales (TASK-054). Point unique à éditer par le PO :
// remplacer TOUS les `[À COMPLÉTER : …]` par l'identité légale réelle de la
// société éditrice avant l'ouverture publique payante, puis faire relire par un
// juriste. Les pages `/legal/*` consomment ces constantes.
//
// ⚠️ Ces textes sont un PREMIER JET rédigé par l'agent — ils ne valent pas un
// conseil juridique. À valider avant mise en ligne.
// ───────────────────────────────────────────────────────────────────

/** Marqueur des champs à remplir — sert aussi d'assertion de test. */
export const LEGAL_PLACEHOLDER_PREFIX = '[À COMPLÉTER';

/** Date de dernière mise à jour affichée sur les pages légales. */
export const LEGAL_LAST_UPDATED = '2026-08-09';

export const PRODUCT = {
  name: 'MenuDigital Pro',
  siteUrl: 'https://quarte.app',
} as const;

/**
 * Identité légale de la société éditrice — À COMPLÉTER par le PO.
 * Obligatoire pour les mentions légales (LCEN art. 6) et les CGV.
 */
export const COMPANY = {
  legalName: '[À COMPLÉTER : raison sociale]',
  legalForm: '[À COMPLÉTER : forme juridique, ex. SAS]',
  shareCapital: '[À COMPLÉTER : capital social, ex. 1 000 €]',
  siren: '[À COMPLÉTER : n° SIREN / SIRET]',
  rcs: '[À COMPLÉTER : ville + n° RCS]',
  vatNumber: '[À COMPLÉTER : n° TVA intracommunautaire]',
  address: '[À COMPLÉTER : adresse du siège social]',
  publicationDirector: '[À COMPLÉTER : nom du directeur de la publication]',
  jurisdictionCity: '[À COMPLÉTER : ville du tribunal compétent]',
  /** Adresse de contact / exercice des droits RGPD. */
  contactEmail: 'support@quarte.app',
} as const;

/** Hébergeur (connu — Firebase / Google Cloud, région UE). */
export const HOSTING = {
  name: 'Google Ireland Limited (Firebase / Google Cloud Platform)',
  address: 'Gordon House, Barrow Street, Dublin 4, Irlande',
  region: 'europe-west1 (Belgique)',
} as const;

/** Sous-traitants (RGPD art. 28) exposés dans la politique de confidentialité. */
export const SUBPROCESSORS: ReadonlyArray<{
  name: string;
  purpose: string;
  location: string;
}> = [
  {
    name: 'Google Firebase',
    purpose: 'Hébergement, authentification, base de données',
    location: 'Union européenne (europe-west1)',
  },
  {
    name: 'Stripe',
    purpose: 'Paiements et abonnements',
    location: 'UE + États-Unis (encadré Data Privacy Framework)',
  },
  { name: 'Resend', purpose: 'Envoi des emails transactionnels', location: 'UE + États-Unis' },
  {
    name: 'Sentry',
    purpose: "Diagnostic technique (journaux d'erreurs)",
    location: 'Union européenne',
  },
];

/** Tarifs affichés dans les CGV (alignés BillingPage / ADR-004). */
export const PRICING = {
  trialDays: 14,
  basicMonthly: '2 €',
  proMonthly: '5 €',
  currency: 'EUR',
} as const;
